<div class="p-3">
	<h3 class="fw-bold mb-3">Suscripciones</h3>

	<ul class="nav nav-tabs mb-2">
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="{active: mode=='summary'}" (click)="mode='summary'">Resumen</a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="{active: mode=='client'}" (click)="mode='client'">Por cliente</a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="{active: mode=='room'}" (click)="mode='room'">Por cuarto</a>
		</li>
	</ul>

	<ng-container *ngIf="mode=='summary'">
		<div class="mb-2 d-flex align-items-end">
			<div class="me-2">Usuarios: <span class="fw-bold">{{total_users}}</span> · Periodos: <span class="fw-bold">{{total_periods}}</span></div>
			<div class="ms-auto" style="max-width:220px">
				<select class="form-control form-control-sm" [(ngModel)]="summary_status" (ngModelChange)="loadSummary()" name="summary_status">
					<option value="ACTIVE">Activas</option>
					<option value="">Todas</option>
					<option value="SUSPENDED">Suspendidas</option>
					<option value="EXPIRED">Expiradas</option>
					<option value="RETURNED">Devueltas</option>
					<option value="CANCELLED">Canceladas</option>
				</select>
			</div>
		</div>
		<div class="card p-2">
			<table class="table table-sm table-striped mb-0">
				<thead>
					<tr>
						<th>Artículo</th>
						<th class="text-end">Usuarios</th>
						<th class="text-end">Periodos</th>
						<th class="text-end">Activos</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let row of summary">
						<tr>
							<td><a class="pointer" (click)="toggleArticle(row)"><span class="me-1">{{expanded_item_id === row.item_id ? '▾' : '▸'}}</span>{{row.item_name}}</a></td>
							<td class="text-end">{{row.user_count}}</td>
							<td class="text-end">{{row.period_count}}</td>
							<td class="text-end">{{row.active_count}}</td>
							<td class="text-end"><button type="button" class="btn btn-secondary btn-sm" (click)="toggleArticle(row)">{{expanded_item_id === row.item_id ? 'Ocultar' : 'Ver'}}</button></td>
						</tr>
						<tr *ngIf="expanded_item_id === row.item_id">
							<td colspan="5" class="p-0">
								<div style="overflow-x:auto" class="p-2 bg-light" *ngIf="article_subscriptions.length">
									<table class="table table-sm table-striped mb-0">
										<thead>
											<tr>
												<th>Cliente</th>
												<th>Periodo</th>
												<th>Estado</th>
												<th class="text-end">Saldo</th>
												<th>Cuarto</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let info of article_subscriptions">
												<td>{{getCustomerName(info)}}</td>
												<td class="text-nowrap">{{info.subscription.starts_at}} → {{info.subscription.expires_at || 'sin expiración'}}</td>
												<td>{{getSubscriptionStatus(info)}}</td>
												<td class="text-end">{{info.subscription.balance_qty != null ? (info.subscription.balance_qty + ' / ' + info.subscription.total_qty) : '—'}}</td>
												<td>{{info.subscription.asset_code || '—'}}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="p-2 text-muted small" *ngIf="!article_subscriptions.length">Cargando…</div>
							</td>
						</tr>
					</ng-container>
					<tr *ngIf="!summary.length">
						<td colspan="5" class="text-muted">Sin resultados.</td>
					</tr>
				</tbody>
			</table>
		</div>
	</ng-container>

	<ng-container *ngIf="mode=='client'">
		<div class="card p-2 mb-2">
			<label>Buscar cliente por nombre</label>
			<input type="text" class="form-control" [(ngModel)]="client_search_str" (ngModelChange)="searchClients()" placeholder="Ej. Diego" autocomplete="off">
			<ul class="list-group mt-1" *ngIf="client_list.length">
				<li class="list-group-item pointer" *ngFor="let client of client_list" (click)="selectClient(client)">
					{{client.name}} <span class="text-muted small" *ngIf="client.phone">- {{client.phone}}</span>
				</li>
			</ul>
		</div>
		<div #client_detail_card class="card p-2" *ngIf="selected_client">
			<h5 class="d-flex justify-content-between align-items-center">{{selected_client.name}} ({{client_subscriptions.length}} suscripciones)
				<button type="button" class="btn btn-secondary btn-sm" (click)="show_client_detail = !show_client_detail">{{show_client_detail ? 'Ocultar' : 'Mostrar'}}</button>
			</h5>
			<ng-container *ngIf="show_client_detail">
			<table class="table table-sm table-striped mb-0">
				<thead>
					<tr>
						<th>Artículo</th>
						<th>Inicia</th>
						<th>Expira</th>
						<th>Estado</th>
						<th class="text-end">Saldo</th>
						<th>Cuarto</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let info of client_subscriptions">
						<td>{{getItemName(info)}}</td>
						<td class="text-nowrap">{{info.subscription.starts_at}}</td>
						<td class="text-nowrap">{{info.subscription.expires_at || 'sin expiración'}}</td>
						<td>{{getSubscriptionStatus(info)}}</td>
						<td class="text-end">{{info.subscription.balance_qty != null ? (info.subscription.balance_qty + ' / ' + info.subscription.total_qty) : '—'}}</td>
						<td>{{info.subscription.asset_code || '—'}}</td>
					</tr>
					<tr *ngIf="!client_subscriptions.length">
						<td colspan="6" class="text-muted">Sin suscripciones.</td>
					</tr>
				</tbody>
			</table>
			</ng-container>
		</div>
	</ng-container>

	<ng-container *ngIf="mode=='room'">
		<div class="card p-2 mb-2">
			<div class="row">
				<div class="col-12 col-md-6 mb-2">
					<label>Tipo de activo</label>
					<select class="form-control" [(ngModel)]="selected_asset_item_id" (ngModelChange)="loadSerials()" name="history_asset_item">
						<option [ngValue]="null">Seleccionar tipo…</option>
						<option *ngFor="let entry of asset_item_list" [ngValue]="entry.item.id">{{entry.item.name}}</option>
					</select>
				</div>
				<div class="col-12 col-md-6 mb-2">
					<label>Cuarto</label>
					<select class="form-control" [(ngModel)]="selected_serial_id" (ngModelChange)="loadSerialHistory()" name="history_serial" [disabled]="!serial_list.length">
						<option [ngValue]="null">Seleccionar cuarto…</option>
						<option *ngFor="let serial of serial_list" [ngValue]="serial.id">{{serial.serial_number}}</option>
					</select>
				</div>
			</div>
		</div>
		<div #room_detail_card class="card p-2" *ngIf="selected_serial_id">
			<h5 class="d-flex justify-content-between align-items-center">Historial ({{serial_history.length}})
				<button type="button" class="btn btn-secondary btn-sm" (click)="show_room_detail = !show_room_detail">{{show_room_detail ? 'Ocultar' : 'Mostrar'}}</button>
			</h5>
			<ng-container *ngIf="show_room_detail">
			<table class="table table-sm table-striped mb-0">
				<thead>
					<tr>
						<th>Cliente</th>
						<th>Artículo</th>
						<th>Periodo</th>
						<th>Estado</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let info of serial_history">
						<td>{{getCustomerName(info)}}</td>
						<td>{{getItemName(info)}}</td>
						<td class="text-nowrap">{{info.subscription.starts_at}} → {{info.subscription.expires_at || 'sin expiración'}}</td>
						<td>{{getSubscriptionStatus(info)}}</td>
					</tr>
					<tr *ngIf="!serial_history.length">
						<td colspan="4" class="text-muted">Sin historial.</td>
					</tr>
				</tbody>
			</table>
			</ng-container>
		</div>
	</ng-container>
</div>
